module.exports = __webpack_public_path__ + "static/media/rightarrow.120c2ff5.png";